export default "__VITE_ASSET__B6xXTHV4__"